export enum NotificationSeverity {
    Info, Warn, Success, Error
}